import { RootState } from '../../../app/reducer';
import { DataState } from '../../../constants';
import { RawStreamModel } from '../../../models';

export const selectRawStreams = ({ rawStreamReducer }: RootState): RawStreamModel[] =>
  rawStreamReducer.rawStreams.data;

export const selectRawStreamsState = ({ rawStreamReducer }: RootState): DataState =>
  rawStreamReducer.rawStreams.state;
